/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable camelcase */
import { createAsyncAction } from 'Helpers/redux'
import { User } from 'Types/index'

import { apiCall } from './api'

export const RESET_USER_BALANCE = 'RESET_USER_BALANCE'
export const resetUserBalance = () => ({
  type: RESET_USER_BALANCE,
})

export const SIGN_UP_ARTIST = createAsyncAction('auth/SIGN_UP_ARTIST')
export const signUpArtist = (
  firstName: string,
  lastName: string,
  password: string,
  email: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gcid: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  utmObj: any,
  callback: () => void
) =>
  apiCall({
    method: 'post',
    endpoint: '/auth/signup-artist',
    query: {
      first_name: firstName,
      last_name: lastName,
      password,
      email,
      gcid,
      utmObj,
    },
    types: SIGN_UP_ARTIST,
    callback,
  })

export const SIGN_UP_CURATOR = createAsyncAction('auth/SIGN_UP')
export const signUpCurator = (
  firstName: string,
  lastName: string,
  password: string,
  email: string,
  callback: () => void
) =>
  apiCall({
    method: 'post',
    endpoint: '/auth/signup-curator',
    query: {
      first_name: firstName,
      last_name: lastName,
      password,
      email,
    },
    types: SIGN_UP_CURATOR,
    callback,
  })

export const SIGN_IN = createAsyncAction('auth/SIGN_IN')
export const signIn = (email: string, password: string, callback: () => void) =>
  apiCall({
    method: 'post',
    endpoint: '/auth/login',
    query: {
      email,
      password,
    },
    types: SIGN_IN,
    callback,
  })

export const SIGN_IN_SPOTIFY = createAsyncAction('SIGN_IN_SPOTIFY')
export function signInSpotify(user: User) {
  return {
    type: SIGN_IN_SPOTIFY.SUCCESS,
    payload: user,
  }
}

export const SET_ROLE_TO_USER = createAsyncAction('SET_ROLE_TO_USER')
export const setRoleToUser = (
  spotify_id: string,
  userType: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  gcid: any,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  utmObj: any,
  access_token: string,
  email: string,
  is_email_confirmed: boolean,
  refresh_token: string,
  user_photo_url: string,
  first_name: string,
  last_name: string,
  callback: () => void
) =>
  apiCall({
    method: 'post',
    endpoint: '/auth/who-are-you',
    query: {
      spotify_id,
      userType,
      gcid,
      utmObj,
      access_token,
      email,
      is_email_confirmed,
      refresh_token,
      user_photo_url,
      first_name,
      last_name,
    },
    types: SET_ROLE_TO_USER,
    callback,
  })

// TODO not usage
export const ACCEPT_TERMS = createAsyncAction('ACCEPT_TERMS')
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const acceptTerms = (terms: any) =>
  apiCall({
    method: 'put',
    endpoint: '/curator/terms',
    query: {
      are_terms_accepted: terms,
    },
    types: ACCEPT_TERMS,
  })

export const ACCEPT_TERMS_NEW = createAsyncAction('ACCEPT_TERMS_NEW')
export const acceptTermsNew = (termsPosition: number, termsCount: number) =>
  apiCall({
    method: 'put',
    endpoint: '/curator/terms',
    query: {
      termsPosition,
      termsCount,
    },
    types: ACCEPT_TERMS_NEW,
  })

export const GET_CURATOR_RANK = createAsyncAction('GET_CURATOR_RANK')
export const getCuratorRank = () =>
  apiCall({
    method: 'get',
    endpoint: '/curator/rank',
    types: GET_CURATOR_RANK,
  })

// TODO not usage
export const CONFIRM_EMAIL = createAsyncAction('CONFIRM_EMAIL')
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const confirmEmail = (payload: any) => ({
  type: CONFIRM_EMAIL,
  payload,
})

export const SET_IS_FIRST_CAMPAIGN = createAsyncAction('SET_IS_FIRST_CAMPAIGN')
export const setIsFirstCampaign = (payload: boolean) => ({
  type: SET_IS_FIRST_CAMPAIGN,
  payload,
})

export const SEND_EMAIL_TO_RESET_PASSWORD = createAsyncAction(
  'SEND_EMAIL_TO_RESET_PASSWORD'
)
export const sendEmailToResetPassword = (email: string, callback: () => void) =>
  apiCall({
    method: 'post',
    endpoint: '/user/reset-password',
    query: {
      email,
    },
    types: SEND_EMAIL_TO_RESET_PASSWORD,
    callback,
  })

export const SEND_EMAIL_TO_CONFIRM_ACCOUNT = createAsyncAction(
  'SEND_EMAIL_TO_CONFIRM_ACCOUNT'
)
export const sendEmailToConfirmAccount = () =>
  apiCall({
    method: 'get',
    endpoint: '/user/send-email',
    types: SEND_EMAIL_TO_CONFIRM_ACCOUNT,
  })

export const RESET_PASSWORD = createAsyncAction('RESET_PASSWORD')
export const resetPassword = (
  password: string,
  uuid: string,
  callback: () => void
) =>
  apiCall({
    method: 'put',
    endpoint: '/user/reset-password',
    query: {
      new_password: password,
      uuid,
    },
    types: RESET_PASSWORD,
    callback,
  })

export const SET_PLAYLIST_REQUIREMENT = createAsyncAction(
  'SET_PLAYLIST_REQUIREMENT'
)

// TODO not usage
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setPlaylistRequirement = (playlist_requirement: any) =>
  apiCall({
    method: 'post',
    endpoint: '/curator/requirements',
    query: {
      playlist_requirement,
    },
    types: SET_PLAYLIST_REQUIREMENT,
  })

export const LOG_OUT = 'LOG_OUT'
export const logOut = () => ({
  type: LOG_OUT,
})

export const REHYDRATE_TOKEN = createAsyncAction('auth/REHYDRATE_TOKEN')
export const rehydrateToken = () => {
  const sessionStorageId = sessionStorage.getItem('user_token')
  const localStorageId = localStorage.getItem('user_token')
  const AccessToken = localStorage.getItem('access')
  const user = localStorage.getItem('user')
  // @ts-ignore
  const isArtist = JSON.parse(localStorage.getItem('isArtist'))
  const role = localStorage.getItem('role')
  const RefreshToken = sessionStorageId || localStorageId

  const isRefreshTokenValid =
    typeof RefreshToken !== 'undefined' && RefreshToken !== null
  const isAccessTokenValid =
    typeof AccessToken !== 'undefined' && AccessToken !== null

  if (isRefreshTokenValid || isAccessTokenValid) {
    return {
      type: REHYDRATE_TOKEN.SUCCESS,
      payload: {
        data: { RefreshToken, AccessToken },
        user: user ? JSON.parse(user) : {},
        isArtist,
        role,
      },
    }
  }
  return {
    type: REHYDRATE_TOKEN.FAILURE,
    payload: {
      data: null,
    },
  }
}

export const UPDATE_TOKEN = createAsyncAction('auth/UPDATE_TOKEN')
export const updateToken = (token: string, meta = {}, callback = null) => (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  dispatch: (arg0: { type: string; fields: any }) => void
  // getState
) => {
  // || getRefreshToken(getState())   TODO - check what is it
  dispatch(
    apiCall({
      endpoint: '/auth/update-creds',
      types: UPDATE_TOKEN,
      headers: {
        Authorization: `Bearer ${token}`,
      },
      callback,
      meta,
    })
  )
}

export const SIGN_IN_AS = createAsyncAction('auth/SIGN_IN_AS')
export const signInAs = (id: number, isArtist: boolean, callback: () => void) =>
  apiCall({
    method: 'post',
    endpoint: '/admin/login',
    query: {
      id,
      isArtist,
    },
    types: SIGN_IN_AS,
    callback,
  })

export const GET_USER_INFO = createAsyncAction('GET_USER_INFO')
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getUserInfo = (callback?: any) =>
  apiCall({
    method: 'get',
    endpoint: '/user/info',
    types: GET_USER_INFO,
    callback,
  })

export const UPDATE_ARTIST = createAsyncAction('UPDATE_ARTIST')
export const updateArtist = (
  firstName: string,
  lastName: string,
  phone_number: string,
  role: string,
  callback: () => void
) =>
  apiCall({
    method: 'patch',
    endpoint: '/artist/update-info',
    query: {
      first_name: firstName,
      last_name: lastName,
      phone_number,
      role,
    },
    types: UPDATE_ARTIST,
    callback,
  })

export const CHECK_USER_EMAIL_TO_SIGN_IN = createAsyncAction(
  'CHECK_USER_EMAIL_TO_SIGN_IN'
)
export const checkUserEmailToSignIn = (email: string, callback: () => void) =>
  apiCall({
    method: 'get',
    endpoint: `/auth/check/${email}`,
    types: CHECK_USER_EMAIL_TO_SIGN_IN,
    callback,
  })

export const SET_LOGIN_TYPE_TO_INITIAL_STATE = 'SET_LOGIN_TYPE_TO_INITIAL_STATE'
export const setLoginTypeToInitialState = () => ({
  type: SET_LOGIN_TYPE_TO_INITIAL_STATE,
})

export const GET_SPOTIFY_AVATAR = createAsyncAction('GET_SPOTIFY_AVATAR')
export const getSpotifyAvatar = (callback: () => void) =>
  apiCall({
    method: 'get',
    endpoint: '/user/profile-avatar',
    types: GET_SPOTIFY_AVATAR,
    callback,
  })

export const SET_COMPLAINTS_READ = createAsyncAction('SET_COMPLAINTS_READ')
export const setComplaintsRead = () =>
  apiCall({
    method: 'post',
    endpoint: '/review/read-complains',
    types: SET_COMPLAINTS_READ,
  })

export const GET_CURRENCY = createAsyncAction('GET_CURRENCY')
export const getCurrencyInfo = () =>
  apiCall({
    method: 'get',
    endpoint: '/user/exchange-rate',
    types: GET_CURRENCY,
  })

export const GET_COUNTRY = createAsyncAction('GET_COUNTRY')
export const getCountry = () =>
  apiCall({
    method: 'get',
    endpoint: 'user/country',
    types: GET_COUNTRY,
  })

export const ACTIVATE_CURATOR = createAsyncAction('ACTIVATE_CURATOR')
export const activateCurator = () =>
  apiCall({
    method: 'patch',
    endpoint: '/curator/activate',
    types: ACTIVATE_CURATOR,
  })

export const SET_GCID_TO_USER = createAsyncAction('SET_GCID_TO_USER')
export const setGcidToUser = (gcid: string, isArtist: boolean) =>
  apiCall({
    method: 'put',
    endpoint: '/auth/gcid',
    query: {
      gcid,
      isArtist,
    },
    types: SET_GCID_TO_USER,
  })

export const SET_IS_NEW_FEED = createAsyncAction('SET_IS_NEW_FEED')
export const setIsNewFeed = () =>
  apiCall({
    method: 'put',
    endpoint: '/curator/feed-alert',
    query: {
      is_new_feed: false,
    },
    types: SET_IS_NEW_FEED,
  })

export const SET_IS_FEED_BANNER = createAsyncAction('SET_IS_FEED_BANNER')
export const setIsFeedBanner = () =>
  apiCall({
    method: 'put',
    endpoint: '/curator/feed-alert',
    query: {
      is_feed_banner: false,
    },
    types: SET_IS_FEED_BANNER,
  })
